import * as Yup from 'yup';
import { textMaxLength } from 'constants/fieldsLimits';
import VALIDATION_MESSAGES from 'constants/validationMessages';

export const commentValidationSchema = Yup.object({
  body: Yup.string().optional().max(textMaxLength, VALIDATION_MESSAGES.STRING_MAX_LENGTH(textMaxLength)),
});
